<template>
  <v-container fluid tag="section" :class="$isMobile ? 'pa-0' : 'pa-0'">
    <v-tabs v-model="tab" v-bind='$attrs'>
      <v-tab>工单详情</v-tab>
      <v-tab>工单记录</v-tab>
      <v-tab>客户详情</v-tab>
      <v-tab v-for="(rel, idx) in item.relationContractInfos" :key="idx">
        {{
          item.relationContractInfos.length === 1 ? '合同详情'
          :
          item.contract.serialNumber === rel.serialNumber
          ?
          '当前合同'
          :
          `关联合同(${rel.serialNumber.substring(rel.serialNumber.lastIndexOf('.')+1,rel.serialNumber.length)})`}}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <detail-view mini :item='item'></detail-view>
      </v-tab-item>
      <v-tab-item>
        <record-view mini :item='item.orderRecords'></record-view>
      </v-tab-item>
      <v-tab-item>
        <customer-detail mini :item='item.customer' lazy></customer-detail>
      </v-tab-item>
      <v-tab-item v-for="(rel, idx) in item.relationContractInfos" :key="idx">
        <contract-detail mini :item='rel' lazy></contract-detail>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import ContractDetail from '@/views/pages/pc/contract/info/components/Detail.vue'
  import CustomerDetail from '@/views/pages/pc/customer/components/Detail.vue'
  import DetailView from './components/Detail.vue'
  import RecordView from './components/Record.vue'

  export default {
    name: 'OrderDetailIndex',
    components: {
      RecordView,
      DetailView,
      CustomerDetail,
      ContractDetail
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        tab: 0
      }
    }
  }
</script>

<style>
</style>
